import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrudLyfisPartnerProfileComponent } from './crud-lyfis-partner-profile/crud-lyfis-partner-profile.component';
import { ManageLyfisPartnerProfileComponent } from './manage-lyfis-partner-profile/manage-lyfis-partner-profile.component';
import { ManageLyfisQuestionsComponent } from './manage-lyfis-questions/manage-lyfis-questions.component';
import { CrudLyfisQuestionComponent } from './crud-lyfis-question/crud-lyfis-question.component';
import { ScorecardCompilerComponent } from './scorecard-compiler/scorecard-compiler.component';
import { ScorecardCompilationsComponent } from './scorecard-compilations/scorecard-compilations.component';
import { LyfisTestingComponent } from './lyfis-testing/lyfis-testing.component';
import { LyfisTraceDetailComponent } from './lyfis-trace-detail/lyfis-trace-detail.component';
import { LyfisViewUsersComponent } from './lyfis-view-users/lyfis-view-users.component';
import { LyfisViewUserSnapshotsComponent } from './lyfis-view-user-snapshots/lyfis-view-user-snapshots.component';
import { LyfisViewSnapshotDiseasesComponent } from './lyfis-view-snapshot-diseases/lyfis-view-snapshot-diseases.component';
import { LyfisPersistedTraceDetailComponent } from './lyfis-persisted-trace-detail/lyfis-persisted-trace-detail.component';
const routes: Routes = [
  {
    path: '',
    component: ManageLyfisPartnerProfileComponent,
  },
  {
    path: 'create',
    component: CrudLyfisPartnerProfileComponent,
  },
  {
    path: 'create/:id',
    component: CrudLyfisPartnerProfileComponent,
  },
  {
    path: 'questions',
    component: ManageLyfisQuestionsComponent,
  },
  {
    path: 'questions/create',
    component: CrudLyfisQuestionComponent,
  },
  {
    path: 'questions/create/:id',
    component: CrudLyfisQuestionComponent,
  },
  {
    path: 'scorecard-compiler',
    component: ScorecardCompilerComponent
  },
  {
    path: 'scorecard-compilations',
    component: ScorecardCompilationsComponent
  },
  {
    path: 'testing',
    component: LyfisTestingComponent
  },
  {
    path: 'trace-detail',
    component: LyfisTraceDetailComponent
  },
  {
    path: 'view-scores',
    component: LyfisViewUsersComponent,
  },
  {
    path: 'view-scores/users/:userId/snapshots',
    component: LyfisViewUserSnapshotsComponent,
  },
  {
    path: 'view-scores/snapshots/:snapshotId/diseases',
    component: LyfisViewSnapshotDiseasesComponent,
  },
  {
    path: 'view-scores/snapshots/:snapshotId/diseases/:diseaseScoreId/trace-detail',
    component: LyfisPersistedTraceDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LyfisRoutingModule { }
